import { render } from "./ClientSlider.vue?vue&type=template&id=0e93ccb8"
import script from "./ClientSlider.vue?vue&type=script&lang=js"
export * from "./ClientSlider.vue?vue&type=script&lang=js"

import "./ClientSlider.vue?vue&type=style&index=0&id=0e93ccb8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__